import { z } from "zod";

import { normalizeTaskHistoryFields } from "./history-fields";
import { LiabilityDeclineReasonSchema } from "./liability-decline";
import { TaskPriority, TaskStatus } from "./schemas";

const TaskHistoryAction = z
  .enum(["create", "status_change", "reassign", "update", "execute", "cancel", "reopen"])
  .describe("The specific operation performed on the task");

export const TaskHistoryEntrySchema = z.object({
  action: TaskHistoryAction.describe("The operation logged in this audit entry"),
  status: TaskStatus.describe("The status of the task after this audit event was committed"),
  waitingStatus: z
    .string()
    .optional()
    .describe("The waiting reason in force after this audit event"),
  assignedTo: z
    .string()
    .nullish()
    .describe("The user ID assigned to the task after this audit event"),
  updatedBy: z.string().min(1).describe("The user ID who performed this change"),
  updatedAt: z.iso.datetime().describe("Precise timestamp of this audit log entry"),
  notes: z
    .string()
    .optional()
    .describe("Optional notes or explanation details provided by the updater"),
  declineReason: LiabilityDeclineReasonSchema.optional().describe(
    "Structured reason selected when the liability analysis was declined",
  ),
  updatedFields: z
    .array(z.string())
    .transform((fields) => normalizeTaskHistoryFields(fields).fields)
    .optional()
    .describe(
      "Stable history field identifiers; legacy entries may contain request property names",
    ),
  priority: TaskPriority.optional().describe(
    "The task's priority at creation; only set for `create`",
  ),
});

export type TaskHistoryEntry = z.infer<typeof TaskHistoryEntrySchema>;
